import React from "react";
import { ImgV2 } from "../../ImgV2";
export const AppWrapper = ({ leftIconUrl, rightIconUrl, leftImageLink, rightImageLink }) => (React.createElement("div", { className: "app-wrapper-root" },
    React.createElement("a", { className: "app-wrapper-root__left-image-container", target: "_blank", rel: "noopener noreferrer", href: leftImageLink },
        React.createElement(ImgV2, { src: leftIconUrl, alt: leftIconUrl })),
    React.createElement("a", { className: "app-wrapper-root__right-image-container", target: "_blank", rel: "noopener noreferrer", href: rightImageLink },
        React.createElement(ImgV2, { src: rightIconUrl, alt: rightIconUrl }))));
